var _path, _path2, _rect, _path3, _path4, _path5, _rect2, _circle, _circle2, _rect3, _rect4, _rect5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66L85 42.5L119.5 66.5L85 90.5L50 66Z",
    fill: "#3C3C3B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 50,
    width: 58,
    height: 45,
    rx: 2,
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108.71C53 107.055 53.9527 105.547 55.4478 104.836L113.322 77.3224C113.771 77.1087 114.187 76.829 114.554 76.4925L117.621 73.6804C120.828 70.7407 126 73.0157 126 77.3662V108C126 110.761 123.761 113 121 113H57.2896C54.9205 113 53 111.079 53 108.71Z",
    fill: "#3C3C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 67L85 90.5L121 67V107H50V67Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 65.9999V103.3C49 106.1 51.3 108.3 54 108.3H116.2C119 108.3 121.2 106 121.2 103.3V65.9999M49 65.9999L85 41.4999L121.2 65.9999M49 65.9999L85 90.4999L121.2 65.9999",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 50,
    width: 58,
    height: 16,
    rx: 2,
    fill: "#F5F6F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 64,
    r: 6,
    fill: "#3C3C3B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 64,
    r: 3,
    fill: "#F5F6F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 62,
    width: 23,
    height: 3,
    fill: "#3C3C3B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 62,
    width: 4,
    height: 8,
    fill: "#3C3C3B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 62,
    width: 3,
    height: 8,
    fill: "#3C3C3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6091 42.2617C49.9091 38.3617 46.2091 34.4617 42.5091 30.4617C41.2091 29.0617 39.1091 31.1617 40.4091 32.5617C44.1091 36.4617 47.8091 40.3617 51.5091 44.3617C52.8091 45.7617 54.9091 43.6617 53.6091 42.2617Z",
    fill: "#4B27E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.625 54.6024C41.225 54.4024 35.825 54.2024 30.425 54.0024C28.525 53.9024 28.525 56.9024 30.425 57.0024C35.825 57.2024 41.225 57.4024 46.625 57.6024C48.525 57.7024 48.525 54.7024 46.625 54.6024Z",
    fill: "#4B27E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.562 44.3617C115.262 40.4617 118.962 36.5617 122.662 32.5617C123.962 31.1617 121.862 29.0617 120.562 30.4617C116.862 34.3617 113.162 38.2617 109.462 42.2617C108.062 43.6617 110.162 45.7617 111.562 44.3617Z",
    fill: "#4B27E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 57.6024C128.9 57.4024 134.3 57.2024 139.7 57.0024C141.6 56.9024 141.6 53.9024 139.7 54.0024C134.3 54.2024 128.9 54.4024 123.5 54.6024C121.5 54.7024 121.5 57.7024 123.5 57.6024Z",
    fill: "#4B27E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.af2c6bb2.svg";
export { ForwardRef as ReactComponent };